import type { V2Route } from './types';
import manga from '../manga/routes';
import ugc from '../ugc/routes';
import song from '../song/routes';
import carousel from '../carousel/routes';
import lp from '../lp/routes';
import image from '../image/routes';
import abtest from '../abtest/routes';
import lpimprove from '../lpimprove/routes';
import adops from '../adops/routes';
import chat from '../chat/routes';
import chatv2 from '../chatv2/routes';
import agents from '../agents/routes';
import docs from '../docs/routes';
import news from '../news/routes';
import account from '../account/routes';
import recipe from '../recipe/routes';
import plans from '../plans/routes';
import banner from '../banner/routes';
import video from '../video/routes';

/**
 * 新UIで作り直した画面の経路の一覧。各担当は自分の routes.ts だけを編集する。
 * ここに無い経路は、旧画面を枠の中に出す（LegacyFrame）。
 */
export const UNIT_ROUTES: V2Route[] = [
  ...manga,
  ...ugc,
  ...song,
  ...carousel,
  ...lp,
  ...image,
  ...abtest,
  ...lpimprove,
  ...adops,
  ...chat,
  ...chatv2,
  ...agents,
  ...docs,
  ...news,
  ...account,
  ...recipe,
  ...plans,
  ...banner,
  ...video,
];
